import { useContext, useEffect, useMemo } from "react";
import useFirmNetworkOrAggregatorOptions from "../../../hooks/useFirmNetworkOrAggregatorOptions";
import { GeaoContext } from "../../../GeaoContextProvider";
import { useFormContext } from "react-hook-form";
import RadioButtonGroup from "../../../../gds/RadioButtonGroup";
import MultiSelectBox from "../../../../gdk/MultiSelectBox";
import AgencyGroupInformation from "./AgencyGroupInformation";
import AgencyCommissionPayments from "./AgencyCommissionPayments";
import ParentAgencyInformation from "./ParentAgencyInformation";
import YesNoOptions from "../../../../../constants/options/YesNoOptions";
import useCobrandedAgency from "../../../hooks/useCobrandedAgency";

export default function AgencyAffiliations() {
    const firmNetworkOrAggregatorOptions = useFirmNetworkOrAggregatorOptions();

    const { agencyInterview } = useContext(GeaoContext);
    const { control, watch, setValue } = useFormContext();
    const { isCobrandedAgency } = useCobrandedAgency();

    const watchAffiliatedWithTop100 = watch("affiliatedWithTop100");
    const watchFirmNetworkOrAggregator = watch("firmNetworkOrAggregator");

    useEffect(() => {
        if (watchAffiliatedWithTop100 === "false") {
            setValue("firmNetworkOrAggregator", null);
            setValue("firmNetworkAggregatorCommissionPayments", null);
        }
    }, [watchAffiliatedWithTop100, firmNetworkOrAggregatorOptions, setValue]);

    const affiliateName = useMemo(
        () => firmNetworkOrAggregatorOptions?.find(o => o.value === watchFirmNetworkOrAggregator?.[0])?.name,
        [watchFirmNetworkOrAggregator, firmNetworkOrAggregatorOptions]
    );

    const agencyName = agencyInterview?.questionAnswers?.AgencyName?.answer ?? "your agency";

    return <>
        <h3 className="margin-top margin-bottom">Agency Affiliations</h3>

        {/* Affiliated with Top 100 question - Hidden for cobranded agencies (defaulted to No) */}
        {!isCobrandedAgency && (
            <RadioButtonGroup trackingId="PrincipalFlow:AgencyOfficeInformation:AgencyAffiliations:AffiliatedWithTop100"
                control={control}
                name="affiliatedWithTop100"
                legend={<>
                    Is your agency affiliated with one of the Insurance Journal Top 100 Firms, a network, or an aggregator?{/*
                    */}<span className='required'>*</span>
                </>}
                layout="Two Column"
                options={YesNoOptions}
            />
        )}

        {!isCobrandedAgency && watchAffiliatedWithTop100 === "true" && firmNetworkOrAggregatorOptions &&
            <MultiSelectBox
                control={control}
                name="firmNetworkOrAggregator"
                label={<>
                    Please select the firm, network or aggregator you work with the most.{/*
                    */}<span className='required'>*</span>
                </>}
                options={firmNetworkOrAggregatorOptions}
                maximumSelectionLength={1}
                descriptiveText="Select only one."
            />
        }

        {!isCobrandedAgency && watchAffiliatedWithTop100 === "true" && watchFirmNetworkOrAggregator != "" &&
            <RadioButtonGroup trackingId="PrincipalFlow:AgencyOfficeInformation:AgencyAffiliations:AffiliateReceivesCommissions"
                control={control}
                name="firmNetworkAggregatorCommissionPayments"
                legend={<>
                    Will {affiliateName} receive commissions payments directly from GEICO for commissions earned by {agencyName}?{/*
                    */}<span className='required'>*</span>
                </>}
                layout="Two Column"
                options={YesNoOptions}
            />
        }

        <AgencyGroupInformation />

        <AgencyCommissionPayments />

        <ParentAgencyInformation />
    </>
}